import { progressBar } from './styles.css'

interface Props {
  currentStep: number
  totalSteps: number
}

export const ProgressBar: React.FC<Props> = ({ currentStep, totalSteps }) => {
  if (totalSteps === 0) {
    return null
  }

  return <div className={progressBar} style={{ width: (100 / totalSteps) * currentStep + '%' }} />
}
